/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect, createContext, useContext } from 'react';
import { isAuthenticated, saveTokens } from '../services/auth.service';
import { useThemeData } from './ThemeDataContext';
import { useMutation } from '@apollo/client';
import { LOGIN_USER } from '../queries';
import Loading from '../screens/loading';

export const AuthContext = createContext(null)

export function useAuthData () {
  return useContext(AuthContext)
}

export function AuthProvider ({ children, setJwt }) {
  const [auth, setAuth] = useState(true)
  const photographerType = useThemeData().photographerType
  const site_id = useThemeData().themeData.site.site_id

  const [loginName, setLoginName] = useState(localStorage.getItem('login_name'))
  const firstPartLogin = loginName !== null ? loginName.replace('["', '') : ''
  const MiddelPartLogin = firstPartLogin.replaceAll('","', ', ')
  const login_name = MiddelPartLogin.replace('"]', '')
  const [logins, setLogins] = useState(photographerType === 'equestrianphotoservice' ? { login_name: 'equestrianphotoservice' } : photographerType === 'professionalphotographer' ? { login_name: 'professionalphotographer' } : { login_name })

  const [clients] = useState({ client_id: 2, client_secret: 'B4qLlm3bRViBRU6D0DNyxn0V9XtXzeLJV7iUHErt' })
  const [jwtState, setJwtState] = useState(0)
  const [user_id, setUserId] = useState(undefined);
  const userid = localStorage.hasOwnProperty('user_id') ? localStorage.getItem('user_id') : undefined;
  // this.setJwtState('test');
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [SnackbarIsOpen, setSnackbarIsOpen] = useState(false);

  const [loginUser,
    { loading: loadingLoginClient }]
    = useMutation(LOGIN_USER, {
      onCompleted (e) {
        let jwt = e.login.access_token
        let logins = e.login.login_name
        let user = e.login.user
        let valuesArrObj = []
        logins.forEach((val) => {
          valuesArrObj.push({
            [val]: val
          })
        })
        //setJwtState(jwtState);
        localStorage.setItem('user_id', user.id)
        localStorage.setItem('site_id', site_id)
        setUserId(user.id);
        setJwt(jwt)
        saveTokens(jwt)
        setAuth(true)
      },
      onError (...error) {
        console.error(error)
      }
    }
  )

  useEffect(() => {
    if (user_id === undefined && userid !== undefined) {
      setUserId(userid)
    }
  }, [user_id, userid])

  useEffect(() => {
    setJwtState(jwtState)
  }, [jwtState, setJwt])

  useEffect(() => {
    if (isAuthenticated(photographerType)) {
      setAuth(true)
    } else {
      if (photographerType !== 'schoolfotos') {
        switch (photographerType) {
          case 'equestrianphotoservice':
            loginUser({
              variables: {
                login_name: 'paardensport@fotoprotools.nl',
                login_password: 'Cradle666!',
                client_id: clients.client_id,
                client_secret: clients.client_secret,
                site_id: site_id,
              }
            })
          break;
          case 'professionalphotographer':
            loginUser({
              variables: {
                login_name: 'photoservice@fotoprotools.nl',
                login_password: 'Cradle666!',
                client_id: clients.client_id,
                client_secret: clients.client_secret,
                site_id: site_id,
              }
            })
          break;
          default:
            break;
        }
      }
      setAuth(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated(photographerType)])

  if (photographerType !== 'schoolfotos') {
    localStorage.setItem('site_id', site_id)
    if (loadingLoginClient) return <Loading/>
    if (auth !== true) return null
    return (
      <AuthContext.Provider value={{ auth, logins, login_name, user_id }}>
        {children}
      </AuthContext.Provider>
    )
  } else {
    if (loadingLogin) return <Loading/>
    return (
      <AuthContext.Provider value={{ auth, logins, setLogins, login_name, loginName, setLoginName, loadingLogin, setLoadingLogin, setSnackbarIsOpen, SnackbarIsOpen }}>
        {children}
      </AuthContext.Provider>
    )
  }
}
